import { render, staticRenderFns } from "./ListVPage.vue?vue&type=template&id=63827802&scoped=true&"
import script from "./ListVPage.vue?vue&type=script&lang=js&"
export * from "./ListVPage.vue?vue&type=script&lang=js&"
import style0 from "./ListVPage.vue?vue&type=style&index=0&id=63827802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63827802",
  null
  
)

export default component.exports